import { inject } from "mobx-react";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import type { Store } from "../../../../client/stores";
import { CurrentConditions } from "../../decoders/Weather.types";
import type { BlockFragment } from "../../generated/webapi.g";
import { reverseRoute } from "../../lib/route";
import { Container, MagicLink } from "../../ui";
import { ArrowIcon } from "../icons/ArrowIcon.component";
import { WeatherIcon } from "../icons/WeatherIcon.component";
import "./WeatherTile.style.scss";

interface WeatherProps {
    weather: CurrentConditions;
    block: BlockFragment;
    store?: Store;
}

export const WeatherTile = inject("store")(({ weather, store, block }: WeatherProps) => {
    if (!store) {
        return null;
    }

    const { site } = store;
    const { t } = useTranslation();
    const weather_market = site.sections.general?.weather_market;
    const url = reverseRoute(site, "weather") || "#";
    useEffect(() => {
        store.storeBlock(block);
    });

    const icon = weather.iconCode ? <WeatherIcon iconCode={weather.iconCode} /> : null;

    return (
        <Container className="component-weather-tile" block={false}>
            <nav className="tile-container">
                <MagicLink className="current-weather" to={url}>
                    <span className="title">{t("current_weather")}</span>
                    <span className="location">{weather_market}</span>
                </MagicLink>
                <MagicLink className="conditions-icon" to={url}>
                    <span className="weather-details">
                        {icon}
                        <span className="temp-current">{weather.temperature}&deg;</span>
                    </span>
                    <ArrowIcon />
                </MagicLink>
            </nav>
        </Container>
    );
});

export default WeatherTile;
